import axios from 'axios'
import { defineStore } from 'pinia'

import api from '@/api'

const CACHE_NAME = 'app'

export default defineStore(CACHE_NAME, {
  state() {
    const stored = localStorage.getItem(CACHE_NAME)
    return stored
      ? JSON.parse(stored)
      : {
          user: null,
          auth: {
            tokens: {
              auth: null,
              refresh: null,
            },
          },
        }
  },

  actions: {
    async signIn(email, password) {
      const { tokens, user_uid } = await api.request({
        method: 'post',
        url: '/auth/sign-in',
        data: { email, password },
      })
      this.auth.tokens = tokens

      this.user = await api.request({
        method: 'get',
        url: `/users/${user_uid}`,
      })

      localStorage.setItem(CACHE_NAME, JSON.stringify(this.$state))
    },

    async refreshTokens() {
      const { data } = await axios.request({
        baseURL: import.meta.env.VITE_BACKEND_URL,
        method: 'post',
        url: '/auth/refresh',
        headers: {
          Authorization: `Bearer ${this.auth.tokens.refresh}`,
        },
      })
      this.auth.tokens = data.tokens

      this.user = await api.request({
        method: 'get',
        url: `/users/${this.user.uid}`,
      })
      localStorage.setItem(CACHE_NAME, JSON.stringify(this.$state))
    },

    signOut() {
      this.$state = {
        user: null,
        auth: {
          tokens: {
            auth: null,
            refresh: null,
          },
        },
      }
      localStorage.removeItem(CACHE_NAME)
    },
  },

  getters: {
    signedIn(state) {
      if (!state.auth?.tokens?.refresh) {
        return false
      }

      try {
        const payload = state.auth.tokens.refresh.split('.')[1]
        const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))

        const claims = JSON.parse(decoded)
        if (!claims?.exp) {
          return false
        }

        const currentTime = Math.floor(Date.now() / 1000)
        return claims.exp > currentTime
      } catch {
        return false
      }
    },
  },
})
